import { Controller } from "@hotwired/stimulus";
import { WebAuthnSigner } from "@dfns/sdk-browser";
import { storage } from "../../../storageconstants";
import { debugError, debugLog, syncCheckoutOverview } from "../../../utils";

export default class FastTrackOtpPermitController extends Controller {
  static values = {
    code:          String,
    session:       String,
    address:       String,
    permitid:      Number,
    challenge:     String,
    permit:        String,
    networkName:   String,
    amountDisplay: String,
  }

  initialize() {
    this.attestation = null;
    this.signing = false;
    this.domain = JSON.parse(sessionStorage.getItem(storage.DOMAIN));
  }

  connect() {
    this.hideLoadingScreen();
    this.challenge = JSON.parse(this.challengeValue);
    this.permit = JSON.parse(this.permitValue);
    syncCheckoutOverview({
      networkName:   this.networkNameValue,
      amountDisplay: this.amountDisplayValue,
    });

    debugLog("FastTrackOtpPermitController connected with:", {
      "code": this.codeValue,
      "session": this.sessionValue,
      "address": this.addressValue,
      "permitId": this.permitidValue,
      "challenge": this.challenge,
    });
  }

  async sign() {
    if (this.signing) {
      debugLog("FastTrackOtpPermit sign() ignored — already in progress");
      return;
    }
    this.signing = true;
    this.showLoadingScreen("Authorizing allowance...");
    try {
      if (!this.challenge) throw new Error("No permit challenge available to sign");
      if (!this.domain)    throw new Error("Domain data not available");

      debugLog("Starting WebAuthn signing for fast-track permit challenge");

      const webauthn = new WebAuthnSigner({
        relyingParty: {
          id:   this.domain.domain,
          name: this.domain.company,
        },
      });
      this.attestation = await webauthn.sign(this.challenge);

      this.submitPermit();
    } catch (error) {
      this.hideLoadingScreen();
      debugError("Error during fast-track permit WebAuthn signing:", error);
    } finally {
      this.signing = false;
    }
  }

  submitPermit() {
    const form = document.getElementById("frame-post-form");
    const challengeEl = document.getElementById("form_challengeIdentifier");
    if (!form || !challengeEl) {
      debugLog("FastTrackOtpPermit submit aborted — form already replaced");
      return;
    }
    challengeEl.value = this.challenge.challengeIdentifier;
    document.getElementById("form_firstFactor").value = JSON.stringify(this.attestation);
    document.getElementById("form_session").value = this.sessionValue;
    document.getElementById("form_permitData").value = JSON.stringify({
      ...this.permit,
      address: this.addressValue,
      session: this.sessionValue,
    });
    form.action = `/${this.codeValue}/sign-fast-track-permit`;
    form.requestSubmit();
  }

  showLoadingScreen(message) {
    this.dispatch("showLoadingScreen", { detail: { text: message || "Please Wait" } });
  }

  hideLoadingScreen() {
    this.dispatch("hideLoadingScreen");
  }
}
